import CloseIcon from '@mui/icons-material/Close';
import { ArrowBackSharp } from '@mui/icons-material';
import Toolbar from 'components/common/Toolbar/Toolbar';
import ELEMENT from 'common/element';

import './EndpointDetailsHeader.scss';

export type EndpointDetailsHeaderProps = {
  onClose: () => void;
  onBack?: () => void;
};

/**
 * This component provides a header with a title and buttons to pin or close the component.
 *
 * @prop onClose        function to close the component
 * @prop onTogglePinned function to handle a click of the Pin button
 * @prop isPinned       true if the view has been pinned
 * @prop title          text for the header
 */
function EndpointDetailsHeader({ onClose, onBack }: EndpointDetailsHeaderProps): JSX.Element {
  const leftItems = !onBack
    ? []
    : [
        <ArrowBackSharp fontSize="small" className="EndpointDetails__Header__Back" onClick={onBack} />,
        <span>Back to Log Details</span>,
      ];
  const rightItems = [
    <div className="Dialog__Close" data-test-id={ELEMENT.inspectFieldsDrawerClose}>
      <CloseIcon onClick={onClose} />
    </div>,
  ];

  return <Toolbar className="EndpointDetails__Header" leftItems={leftItems} rightItems={rightItems} />;
}

export default EndpointDetailsHeader;
